import axios, { AxiosError } from 'axios';

import { ErrorCodes, SaveErrors } from '~/core/constants';
import { ApiResponseError, PostError } from '~/core/types';
import { NotifierType, showNotification } from '~/legacy/components';

export const handlePostError = (error: PostError): void => {
  if (typeof error === 'string') {
    handleSaveErrors(error);
  } else if (axios.isAxiosError(error)) {
    handleAxiosErrors(error);
  } else if (error) {
    handleGenericError(error as Error);
  }
};

const handleSaveErrors = (error: SaveErrors): void => {
  switch (error) {
    case SaveErrors.NO_ESTIMATE_NUMBER:
      showNotification(
        NotifierType.ERROR,
        'Estimate Saved Error',
        'Estimate save error',
        'Customer email does not match existing estimate. Please contact customer support.',
        0
      );
      break;
    case SaveErrors.API_ERROR:
      showNotification(
        NotifierType.ERROR,
        'API Error',
        'An API error occurred',
        'Please check your network connection and try again.',
        0
      );
      break;
    case SaveErrors.IME_REJECTED:
      showNotification(
        NotifierType.ERROR,
        'IME Rejection',
        'Your input has been rejected by IME',
        'Please review your entries and submit again.',
        0
      );
      break;
  }
};

const handleAxiosErrors = (error: AxiosError): void => {
  if (error.response) {
    const data = error.response.data as ApiResponseError;

    if (
      error.response.status === 400 &&
      data.errorCode === ErrorCodes.BAD_ESTIMATION
    ) {
      showNotification(
        NotifierType.ERROR,
        `Error Processing Estimate`,
        'Your estimate has been saved successfully, but was rejected by IME',
        'Please check the portal for updated estimate information',
        0
      );
    } else if (error.response.status === 422 && data.validationErrors) {
      const errorMessages = data.validationErrors
        .map((v) => v.errorMessage)
        .join(', ');

      showNotification(
        NotifierType.ERROR,
        `Save Estimate Error ${error.response.status}`,
        data.errorMessage,
        errorMessages,
        0
      );
    } else {
      showNotification(
        NotifierType.ERROR,
        'Save Estimate Error',
        'There was an error when saving this estimate',
        data.errorMessage || error.message,
        0
      );
    }
  } else {
    showGenericNetworkError(error);
  }
};

const handleGenericError = (error: Error): void => {
  showNotification(
    NotifierType.ERROR,
    'Unknown Error',
    'An unknown error occurred',
    error.message || 'An unexpected error occurred. Please try again.',
    0
  );
};

const showGenericNetworkError = (error: AxiosError): void => {
  showNotification(
    NotifierType.ERROR,
    'Network Error',
    'A network error occurred',
    error.message || 'No response received from the server.',
    0
  );
};
